<template>
	<div class="content-wrapper calendar-position-modified">
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb :page-title="$t('cashbox')" :directory="$t('cashbox')" :icon="'pie-chart'" />
			</div>
			<div class="col-sm-12 col-md-6">
				<app-input type="single-checkbox" :list-value-field="$t('all_museums')" v-model="allMuseums"
					@input="changeAllMuseums()" />
			</div>
		</div>


		<div class="row">
			<div class="col-xl-12 mb-primary">
				<div class="card card-with-shadow border-0">
					<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
						<template v-if="windowTop > 200">
							<ul
								class="nav tab-filter-menu justify-content-flex-end fixed-top p-primary bg-white navbar">
								<li class="nav-item" v-for="(item, index) in chartFilterOptions" :key="index">
									<a href="#" class="nav-link py-0"
										:class="[dealsFilter == item.id ? 'active' : index === 0 && dealsFilter === '' ? 'active' : '']"
										@click.prevent="dealsFilterValue(item.id)">
										<h6>{{ item.value }}</h6>
									</a>
								</li>
							</ul>
						</template>
						<template v-else>
							<ul class="nav tab-filter-menu justify-content-flex-end">
								<li class="nav-item" v-for="(item, index) in chartFilterOptions" :key="index">
									<a href="#" class="nav-link py-0"
										:class="[dealsFilter == item.id ? 'active' : index === 0 && dealsFilter === '' ? 'active' : '']"
										@click.prevent="dealsFilterValue(item.id)">
										<h6>{{ item.value }}</h6>
									</a>
								</li>
							</ul>
						</template>
					</div>

					<div class="card-body">
						<div class="row">
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("museum_visitors") }}</h5>
									</div>
									<div class="card-body">
										<div class="text-justify">
											<app-overlay-loader v-if="lineChartLoadVisitors" />
											<template v-else>
												<template v-if="dealsFilterSort == 1">
													<vue-gauge :refid="'type-unique-id'"
														:class="'d-flex justify-content-center'" :options="lineGug">
													</vue-gauge>
												</template>
												<div class="gauge-title text-center" :style="StyleGug">
													{{ DisplayVisitors }}
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("museum_revenue") }}</h5>
									</div>
									<div class="card-body">
										<div class="text-justify">
											<app-overlay-loader v-if="lineChartLoadFin" />
											<template v-else>
												<template v-if="dealsFilterSort == 1">
													<vue-gauge :refid="'gugfin'"
														:class="'d-flex justify-content-center'" :options="lineGugFin">
													</vue-gauge>
												</template>
												<div class="gauge-title text-center" :style="StyleGug">
													{{ numberWithCurrencyMuseum(DisplayFin) }}
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("gender") }}</h5>
									</div>
									<div class="card-body">
										<div class="row">
											<app-overlay-loader v-if="lineChartLoadSex" />
											<template v-else>
												<div class="col-xl-7">
													<app-chart class="mb-primary" type="pie-chart" :height="300"
														:labels="labelsSex" :data-sets="lineTypeSex" />
												</div>
												<div class="col-xl-5">
													<div class="chart-data-list">
														<div class="justify-content-center">
															<div class="small-line-chart"
																v-for="(item, index) in listSex" :key="index">
																<div class="data-group-item" :style="item.color">
																	<span class="square"
																		:style="item.background_color" />
																	<span class="value">{{ item.value }}% </span>
																	<span>{{ item.name }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("age") }}</h5>
									</div>
									<div class="card-body">
										<div class="text-justify">
											<app-overlay-loader v-if="lineChartLoadAge" />
											<template v-else>
												<app-chart class="mb-primary" type="bar-chart" :height="300"
													:labels="labelsAge" :data-sets="lineTypeAge" />
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("visit_number") }}</h5>
									</div>
									<div class="card-body">
										<div class="row">
											<app-overlay-loader v-if="lineChartLoadVis" />
											<template v-else>
												<div class="col-xl-7">
													<app-chart class="mb-primary" type="pie-chart" :height="300"
														:labels="labelsVis" :data-sets="lineTypeVis" />
												</div>
												<div class="col-xl-5">
													<div class="chart-data-list">
														<div class="justify-content-center">
															<div class="small-line-chart"
																v-for="(item, index) in listVis" :key="index">
																<div class="data-group-item" :style="item.color">
																	<span class="square"
																		:style="item.background_color" />
																	<span class="value">{{ item.value }}% </span>
																	<span>{{ item.name }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("visit_types") }}</h5>
									</div>
									<div class="card-body">
										<div class="row">
											<app-overlay-loader v-if="lineChartLoadPipeline" />
											<template v-else>
												<div class="col-xl-7">
													<app-chart class="mb-primary" type="pie-chart" :height="300"
														:labels="labelsPipeline" :data-sets="lineTypePipeline" />
												</div>
												<div class="col-xl-5">
													<div class="chart-data-list">
														<div class="justify-content-center">
															<div class="small-line-chart"
																v-for="(item, index) in listPipeline" :key="index">
																<div class="data-group-item" :style="item.color">
																	<span class="square"
																		:style="item.background_color" />
																	<span class="value">{{ item.value }}% </span>
																	<span>{{ item.name }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("ticket_types") }}</h5>
									</div>
									<div class="card-body">
										<div class="row">
											<app-overlay-loader v-if="lineChartLoadStage" />
											<template v-else>
												<div class="col-xl-7">
													<app-chart class="mb-primary" type="pie-chart" :height="300"
														:labels="labelsStage" :data-sets="lineTypeStage" />
												</div>
												<div class="col-xl-5">
													<div class="chart-data-list">
														<div class="justify-content-center">
															<div class="small-line-chart"
																v-for="(item, index) in listStage" :key="index">
																<div class="data-group-item" :style="item.color">
																	<span class="square"
																		:style="item.background_color" />
																	<span class="value">{{ item.value }}% </span>
																	<span>{{ item.name }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("where_did_you_hear") }}</h5>
									</div>
									<div class="card-body">
										<div class="row">
											<app-overlay-loader v-if="lineChartLoadTraf" />
											<template v-else>
												<div class="col-xl-7">
													<app-chart class="mb-primary" type="pie-chart" :height="300"
														:labels="labelsTraf" :data-sets="lineTypeTraf" />
												</div>
												<div class="col-xl-5">
													<div class="chart-data-list">
														<div class="justify-content-center">
															<div class="small-line-chart"
																v-for="(item, index) in listTraf" :key="index">
																<div class="data-group-item" :style="item.color">
																	<span class="square"
																		:style="item.background_color" />
																	<span class="value">{{ item.value }}% </span>
																	<span>{{ item.name }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">

							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("payment_types") }}</h5>
									</div>
									<div class="card-body">
										<div class="row">
											<app-overlay-loader v-if="lineChartLoadPay" />
											<template v-else>
												<div class="col-xl-7">
													<app-chart class="mb-primary" type="pie-chart" :height="300"
														:labels="labelsPay" :data-sets="lineTypePay" />
												</div>
												<div class="col-xl-5">
													<div class="chart-data-list">
														<div class="justify-content-center">
															<div class="small-line-chart"
																v-for="(item, index) in listPay" :key="index">
																<div class="data-group-item" :style="item.color">
																	<span class="square"
																		:style="item.background_color" />
																	<span class="value">{{ item.value }}% </span>
																	<span>{{ item.name }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("age") }}</h5>
									</div>
									<div class="card-body">
										<div class="row">
											<app-overlay-loader v-if="lineChartLoadAge" />
											<template v-else>
												<div class="col-xl-7">
													<app-chart class="mb-primary" type="pie-chart" :height="300"
														:labels="labelsAge" :data-sets="lineTypeAges" />
												</div>
												<div class="col-xl-5">
													<div class="chart-data-list">
														<div class="justify-content-center">
															<div class="small-line-chart"
																v-for="(item, index) in listAge" :key="index">
																<div class="data-group-item" :style="item.color">
																	<span class="square"
																		:style="item.background_color" />
																	<span class="value">{{ item.value }}% </span>
																	<span>{{ item.name }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!---<div class="row">
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("audio_guide_languages") }}</h5>
									</div>
									<div class="card-body">
										<div class="row">
											<app-overlay-loader v-if="lineChartLoadGid" />
											<template v-else>
												<div class="col-xl-7">
													<app-chart class="mb-primary" type="pie-chart" :height="300"
														:labels="labelsGid" :data-sets="lineTypeGid" />
												</div>
												<div class="col-xl-5">
													<div class="chart-data-list">
														<div class="justify-content-center">
															<div class="small-line-chart" v-for="(item, index) in listGid"
																:key="index">
																<div class="data-group-item" :style="item.color">
																	<span class="square" :style="item.background_color" />
																	<span class="value">{{ item.value }}% </span>
																	<span>{{ item.name }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-6 mb-4">
								<div class="card card-with-search border-0 card-with-shadow">
									<div class="card-header d-flex align-items-center p-primary bg-transparent">
										<h5 class="card-title d-inline-block mb-0">{{ $t("age") }}</h5>
									</div>
									<div class="card-body">
										<div class="row">
											<app-overlay-loader v-if="lineChartLoadAge" />
											<template v-else>
												<div class="col-xl-7">
													<app-chart class="mb-primary" type="pie-chart" :height="300"
														:labels="labelsAge" :data-sets="lineTypeAges" />
												</div>
												<div class="col-xl-5">
													<div class="chart-data-list">
														<div class="justify-content-center">
															<div class="small-line-chart" v-for="(item, index) in listAge"
																:key="index">
																<div class="data-group-item" :style="item.color">
																	<span class="square" :style="item.background_color" />
																	<span class="value">{{ item.value }}% </span>
																	<span>{{ item.name }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>-->
					</div>
				</div>
			</div>



		</div>



	</div>
</template>


<script>



import VueGauge from 'vue-gauge';


import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { dealStatus, tag, owner, contactType } from "@app/Mixins/Global/FilterMixins";
import { FormMixin } from "../../../../core/mixins/form/FormMixin";


import { formatDateToLocal, formatDateTimeToLocal, numberWithCurrencySymbol, urlGenerator, numberWithCurrencyMuseum } from "@app/Helpers/helpers";
import { getCustomFileds } from "@app/Mixins/Global/CustomFieldMixin";

export default {
	name: "Cashbox",
	extends: CoreLibrary,
	mixins: [FormMixin],
	components: { VueGauge },
	data() {
		return {
			numberWithCurrencyMuseum,
			dataload: false,
			formatDateTimeToLocal,
			saveDealsFilter: 'this_day',
			lineChartLoad: false,
			lineChartLoadSex: false,
			lineChartLoadVisitors: false,
			lineChartLoadFin: false,
			lineChartLoadVis: false,
			lineChartLoadPipeline: false,
			lineChartLoadStage: false,
			lineChartLoadTraf: false,
			lineChartLoadShop: false,
			lineChartLoadPay: false,
			lineChartLoadGid: false,
			lineChartLoadAge: false,
			lineChartLoadVel: false,
			pipelineDataload: false,
			isDealModalActive: false,
			tableId: "deal-modal",
			MoreTitle: "test",
			selectedUrlReason: "",
			allMuseums: localStorage.getItem("all_museums") === "true" ? true : false,
			deal: "",
			value: 0,
			currentPipeline: "",
			localPipelineId: "",
			selectedPipeline: "",
			pipelineValue: "",
			StyleGug: "",
			ClassGug: {
				'fixed-top': false,
				'p-primary': false,
				'bg-white': false,
				'navbar': false,
				'nav': true,
				'tab-filter-menu': true,
				'justify-content-flex-end': true,

			},
			pipelineInitValue: 1,
			isPipelineEmpty: false,


			chartFilterOptions: [
				{ "id": "this_day", "value": this.$t("this_day") },
				{ "id": "last_day", "value": this.$t("last_day") },
				{ "id": "mod_week_this", "value": this.$t("this_week") },
				{ "id": "mod_week_last", "value": this.$t("last_week") },
				{ "id": "this_month", "value": this.$t("this_month") },
				{ "id": "last_month", "value": this.$t("last_month") },
				{ "id": "this_year", "value": this.$t("this_year") },
			],
			dealsFilter: 'this_day',
			dealsFilterSort: 0,
			labelsSex: ['Мужской', 'Женский'],
			labelsVis: ['1-й раз', 'Постоянный'],
			labelsPipeline: ['Выставка', 'Экскурсия', 'Лекция', 'Ивент'],
			labelsStage: ['Полный', 'Студенческий', 'Льготный', 'Пара', 'Детский'],
			labelsTraf: ['Рекомендация', 'Интернет', 'Facebook', 'Instagram', 'Мессенджер', 'Тик-Ток'],
			labelsShop: ['Платок Мужской', 'Платок Женский', 'Футболка', 'Книга', 'Каталог', 'Антик'],
			labelsPay: ['Наличными 2', 'Картой', 'Онлайн', 'Бесплатно'],
			labelsGid: ['Русский', 'Без аудиогида', 'Украинский', 'Английский', 'Китайский'],
			labelsAge: ['0-5', '5-16', '16-25', '25-40', '40-60', 'Пенсионеры'],
			lineChartLabels: [this.$t("plan_data"), this.$t("actual_data")],
			lineChartLabelsVel: [this.$t("plan_data"), this.$t("actual_data_vel")],
			lineGug: {
				chartWidth: 500,
				arcColors: ['#30B32D', '#FFDD00', '#F03E3E'],
				arcDelimiters: [70, 85],
				arcLabels: ['800', '1000'],
				arcLabelFontSize: 14,
				rangeLabel: ['0', '1200'],
				needleValue: 10,
				needleColor: '#000000',
				rangeLabelFontSize: 22,
			},
			lineGugFin: {
				chartWidth: 500,
				arcColors: ['#30B32D', '#FFDD00', '#F03E3E'],
				arcDelimiters: [70, 85],
				arcLabels: ['60000', '75000'],
				arcLabelFontSize: 14,
				rangeLabel: ['0', '95000'],
				needleValue: 50,
				needleColor: '#000000',
				rangeLabelFontSize: 22,
			},
			lineTypeSex: [
				{
					backgroundColor: ['#da0037', '#27AE60'],
					data: [50, 50],
					borderWidth: 0,
				}
			],
			lineTypeAge: [
				{
					label: "к-во",
					backgroundColor: "#4466F2",
					barThickness: 40,
					data: [],
					borderWidth: 0,
				}
			],
			lineTypeVis: [
				{
					backgroundColor: ['#da0037', '#27AE60'],
					data: [50, 50],
					borderWidth: 0,
				}
			],
			lineTypePipeline: [
				{
					backgroundColor: ['#da0037', '#27AE60', '#4466F2', '#FFDD00'],
					data: [25, 25, 25, 25],
					borderWidth: 0,
				}
			],
			lineTypeStage: [
				{
					backgroundColor: ['#da0037', '#27AE60', '#4466F2', '#FFDD00', '#711c9a'],
					data: [15, 15, 15, 15, 15],
					borderWidth: 0,
				}
			],
			lineTypeTraf: [
				{
					backgroundColor: ['#da0037', '#27AE60', '#4466F2', '#bc9d00', '#711c9a', '#d04f08', '#ed9c94', '#ea4fea', '#6ca5b7', '#5936f8', '#6dd739', '#5153fe', '#101e94', '#c6e18a', '#277603', '#6bfec3', '#d0b949', '#12b17e', '#bf6038', '#c54847'],
					data: [15, 15, 15, 15, 15],
					borderWidth: 0,
				}
			],
			lineTypeShop: [
				{
					backgroundColor: ['#da0037', '#27AE60', '#4466F2', '#FFDD00', '#711c9a', '#d04f08'],
					data: [10, 15, 15, 15, 15, 30],
					borderWidth: 0,
				}
			],
			lineTypePay: [
				{
					backgroundColor: ['#da0037', '#27AE60', '#4466F2', '#FFDD00'],
					data: [15, 15, 15, 15],
					borderWidth: 0,
				}
			],
			lineTypeGid: [
				{
					backgroundColor: ['#da0037', '#27AE60', '#4466F2', '#FFDD00', '#711c9a'],
					data: [15, 15, 15, 15, 15],
					borderWidth: 0,
				}
			],
			lineTypeAges: [
				{
					backgroundColor: ['#da0037', '#27AE60', '#4466F2', '#FFDD00', '#711c9a', '#d04f08'],
					data: [15, 15, 15, 15, 15],
					borderWidth: 0,
				}
			],
			lineChartData: [
				{
					backgroundColor: ['#da0037', '#27AE60'],
					data: [100, 0],
					borderWidth: 0,
				}
			],
			lineChartDataVel: [
				{
					backgroundColor: ['#da0037', '#27AE60'],
					data: [0, 100],
					borderWidth: 0,
				}
			],
			listSex: [
				{
					key: 'man',
					name: 'Мужчины',
					background_color: 'background-color: #da0037;',
					color: 'color: #da0037;',
					value: 5,
				},
				{
					key: 'woman',
					name: 'Женщины',
					background_color: 'background-color: #27AE60;',
					color: 'color: #27AE60;',
					value: 6,
				},
			],
			listVis: [
				{
					key: '1',
					name: '1-й раз',
					background_color: 'background-color: #da0037;',
					color: 'color: #da0037;',
					value: 5,
				},
				{
					key: '2',
					name: 'Постоянный',
					background_color: 'background-color: #27AE60;',
					color: 'color: #27AE60;',
					value: 6,
				},
			],
			listPipeline: [
				{
					key: '1',
					name: 'Выставка',
					background_color: 'background-color: #da0037;',
					color: 'color: #da0037;',
					value: 5,
				},
				{
					key: '2',
					name: 'Экскурсия',
					background_color: 'background-color: #27AE60;',
					color: 'color: #27AE60;',
					value: 6,
				},
				{
					key: '3',
					name: 'Лекция',
					background_color: 'background-color: #4466F2;',
					color: 'color: #4466F2;',
					value: 6,
				},
				{
					key: '4',
					name: 'Ивент',
					background_color: 'background-color: #FFDD00;',
					color: 'color: #bc9d00;',
					value: 6,
				},
			],
			listStage: [
				{
					key: '1',
					name: 'Полный',
					background_color: 'background-color: #da0037;',
					color: 'color: #da0037;',
					value: 5,
				},
				{
					key: '2',
					name: 'Студенческий',
					background_color: 'background-color: #27AE60;',
					color: 'color: #27AE60;',
					value: 6,
				},
				{
					key: '3',
					name: 'Льготный',
					background_color: 'background-color: #4466F2;',
					color: 'color: #4466F2;',
					value: 6,
				},
				{
					key: '4',
					name: 'Пара',
					background_color: 'background-color: #FFDD00;',
					color: 'color: #bc9d00;',
					value: 6,
				},
				{
					key: '5',
					name: 'Детский',
					background_color: 'background-color: #711c9a;',
					color: 'color: #711c9a;',
					value: 6,
				},
			],
			listTraf: [
				{
					key: '1',
					name: 'Рекомендация',
					background_color: 'background-color: #da0037;',
					color: 'color: #da0037;',
					value: 5,
				},
				{
					key: '2',
					name: 'Интернет',
					background_color: 'background-color: #27AE60;',
					color: 'color: #27AE60;',
					value: 6,
				},
				{
					key: '3',
					name: 'Facebook',
					background_color: 'background-color: #4466F2;',
					color: 'color: #4466F2;',
					value: 6,
				},
				{
					key: '4',
					name: 'Instagram',
					background_color: 'background-color: #FFDD00;',
					color: 'color: #bc9d00;',
					value: 6,
				},
				{
					key: '5',
					name: 'Мессенджер',
					background_color: 'background-color: #711c9a;',
					color: 'color: #711c9a;',
					value: 6,
				},
				{
					key: '6',
					name: 'Тик-ток',
					background_color: 'background-color: #d04f08;',
					color: 'color: #d04f08;',
					value: 6,
				},
			],
			listShop: [
				{
					key: '1',
					name: 'Платок Мужской',
					background_color: 'background-color: #da0037;',
					color: 'color: #da0037;',
					value: 5,
				},
				{
					key: '2',
					name: 'Платок Женский',
					background_color: 'background-color: #27AE60;',
					color: 'color: #27AE60;',
					value: 6,
				},
				{
					key: '3',
					name: 'Футболка',
					background_color: 'background-color: #4466F2;',
					color: 'color: #4466F2;',
					value: 6,
				},
				{
					key: '4',
					name: 'Книга',
					background_color: 'background-color: #FFDD00;',
					color: 'color: #bc9d00;',
					value: 6,
				},
				{
					key: '5',
					name: 'Каталог',
					background_color: 'background-color: #711c9a;',
					color: 'color: #711c9a;',
					value: 6,
				},
				{
					key: '6',
					name: 'Антик',
					background_color: 'background-color: #d04f08;',
					color: 'color: #d04f08;',
					value: 6,
				},
			],
			listPay: [
				{
					key: '1',
					name: 'Наличными 2',
					background_color: 'background-color: #da0037;',
					color: 'color: #da0037;',
					value: 5,
				},
				{
					key: '2',
					name: 'Картой',
					background_color: 'background-color: #27AE60;',
					color: 'color: #27AE60;',
					value: 6,
				},
				{
					key: '3',
					name: 'Онлайн',
					background_color: 'background-color: #4466F2;',
					color: 'color: #4466F2;',
					value: 6,
				},
				{
					key: '4',
					name: 'Бесплатно',
					background_color: 'background-color: #FFDD00;',
					color: 'color: #bc9d00;',
					value: 6,
				},
			],
			listGid: [
				{
					key: '1',
					name: 'Русский',
					background_color: 'background-color: #da0037;',
					color: 'color: #da0037;',
					value: 5,
				},
				{
					key: '2',
					name: 'Без аудиогида',
					background_color: 'background-color: #27AE60;',
					color: 'color: #27AE60;',
					value: 6,
				},
				{
					key: '3',
					name: 'Украинский',
					background_color: 'background-color: #4466F2;',
					color: 'color: #4466F2;',
					value: 6,
				},
				{
					key: '4',
					name: 'Английский',
					background_color: 'background-color: #FFDD00;',
					color: 'color: #bc9d00;',
					value: 6,
				},
				{
					key: '5',
					name: 'Китайский',
					background_color: 'background-color: #711c9a;',
					color: 'color: #711c9a;',
					value: 6,
				},
			],
			listAge: [
				{
					key: '1',
					name: '0-5',
					background_color: 'background-color: #da0037;',
					color: 'color: #da0037;',
					value: 5,
				},
				{
					key: '2',
					name: '5-16',
					background_color: 'background-color: #27AE60;',
					color: 'color: #27AE60;',
					value: 6,
				},
				{
					key: '3',
					name: '16-25',
					background_color: 'background-color: #4466F2;',
					color: 'color: #4466F2;',
					value: 6,
				},
				{
					key: '4',
					name: '25-40',
					background_color: 'background-color: #FFDD00;',
					color: 'color: #bc9d00;',
					value: 6,
				},
				{
					key: '5',
					name: '40-60',
					background_color: 'background-color: #711c9a;',
					color: 'color: #711c9a;',
					value: 6,
				},
				{
					key: '6',
					name: 'Пенсионеры',
					background_color: 'background-color: #d04f08;',
					color: 'color: #d04f08;',
					value: 6,
				},
			],
			lineChartFilterValue: 'status_won',
			PlanJan: null,
			PlanFeb: null,
			PlanMar: null,
			PlanApr: null,
			PlanMay: null,
			PlanJun: null,
			PlanJul: null,
			PlanAug: null,
			PlanSep: null,
			PlanOct: null,
			PlanNov: null,
			PlanDec: null,
			PlanData: null,
			PlanDataSum: null,
			PlanTest: null,
			PlanSumSep: null,
			PlanThisMonth: null,
			PlanLastMonth: null,
			ActMon: null,
			ActDay: null,
			ActDayMin: null,
			DayPercent: null,
			ClMn: null,
			DayPercentMin: null,
			totalDealOverview: null,
			totalDealOverviewVel: null,
			trafDeal: null,
			itrafDeal: null,
			ftrafDeal: null,
			ntrafDeal: null,
			mtrafDeal: null,
			etrafDeal: null,
			PlanYear: null,
			PlanSummYear: null,
			DisplayVisitors: null,
			DisplayFin: null,
			windowTop: 0,
			windowWidth: 0,

		}
	},



	mounted() {

		window.addEventListener("scroll", this.onScroll);





		this.getData();
		this.getScreen();
		this.dealLoad();
		$("#deal-modal").on("hidden.bs.modal", () => {
			this.isDealModalActive = false;
		});
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.onScroll)
	},
	methods: {
		changeAllMuseums() {
			// this.allMuseums =this.allMuseums == true ? false : true;
			localStorage.setItem("all_museums", this.allMuseums);
			this.dealsFilterValue(this.saveDealsFilter);
		},
		onScroll(e) {
			this.windowTop = window.top.scrollY /* or: e.target.documentElement.scrollTop */
		},

		getScreen() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth < 1200) {
				this.lineGug.chartWidth = 300;
				this.lineGugFin.chartWidth = 300;
			} else {
				if (this.windowTop > 200) {
					this.ClassGug = {
						'fixed-top': true,
						'p-primary': true,
						'bg-white': true,
						'navbar': true,
						'nav': true,
						'tab-filter-menu': true,
						'justify-content-flex-end': true,
					}
				} else {
					this.ClassGug = {
						'fixed-top': false,
						'p-primary': false,
						'bg-white': false,
						'navbar': false,
						'nav': true,
						'tab-filter-menu': true,
						'justify-content-flex-end': true,
					}
				}
			}

		},


		getData() {



			this.axiosGet(`admin/app/settings`).then(response => {
				this.appSettings = response.data;
				var d = new Date();
				this.ActMon = d.getMonth();
				this.ActDay = d.getDate();




				if (this.ActMon == 0) {
					this.PlanThisMonth = this.appSettings.planjan;
					this.PlanLastMonth = this.appSettings.plandec;
					this.PlanThisMonthSum = this.appSettings.plansumjan;
					this.PlanLastMonthSum = this.appSettings.plansumdec;
					this.ManyDay = 31;
				} else if (this.ActMon == 1) {
					this.PlanThisMonth = this.appSettings.planfeb;
					this.PlanLastMonth = this.appSettings.planjan;
					this.PlanThisMonthSum = this.appSettings.plansumfeb;
					this.PlanLastMonthSum = this.appSettings.plansumjan;
					this.ManyDay = 28;
				} else if (this.ActMon == 2) {
					this.PlanThisMonth = this.appSettings.planmar;
					this.PlanLastMonth = this.appSettings.planfeb;
					this.PlanThisMonthSum = this.appSettings.plansummar;
					this.PlanLastMonthSum = this.appSettings.plansumfeb;
					this.ManyDay = 31;
				} else if (this.ActMon == 3) {
					this.PlanThisMonth = this.appSettings.planapr;
					this.PlanLastMonth = this.appSettings.planmar;
					this.PlanThisMonthSum = this.appSettings.plansumapr;
					this.PlanLastMonthSum = this.appSettings.plansummar;
					this.ManyDay = 30;
				} else if (this.ActMon == 4) {
					this.PlanThisMonth = this.appSettings.planmay;
					this.PlanLastMonth = this.appSettings.PlanApr;
					this.PlanThisMonthSum = this.appSettings.plansummay;
					this.PlanLastMonthSum = this.appSettings.plansumapr;
					this.ManyDay = 31;
				} else if (this.ActMon == 5) {
					this.PlanThisMonth = this.appSettings.planjun;
					this.PlanLastMonth = this.appSettings.planmay;
					this.PlanThisMonthSum = this.appSettings.plansumjun;
					this.PlanLastMonthSum = this.appSettings.plansummay;
					this.ManyDay = 30;
				} else if (this.ActMon == 6) {
					this.PlanThisMonth = this.appSettings.planjul;
					this.PlanLastMonth = this.appSettings.planjun;
					this.PlanThisMonthSum = this.appSettings.plansumjul;
					this.PlanLastMonthSum = this.appSettings.plansumjun;
					this.ManyDay = 31;
				} else if (this.ActMon == 7) {
					this.PlanThisMonth = this.appSettings.planaug;
					this.PlanLastMonth = this.appSettings.planjul;
					this.PlanThisMonthSum = this.appSettings.plansumaug;
					this.PlanLastMonthSum = this.appSettings.plansumjul;
					this.ManyDay = 31;
				} else if (this.ActMon == 8) {
					this.PlanThisMonth = this.appSettings.plansep;
					this.PlanLastMonth = this.appSettings.planaug;
					this.PlanThisMonthSum = this.appSettings.plansumsep;
					this.PlanLastMonthSum = this.appSettings.plansumaug;
					this.ManyDay = 30;
				} else if (this.ActMon == 9) {
					this.PlanThisMonth = this.appSettings.planoct;
					this.PlanLastMonth = this.appSettings.plansep;
					this.PlanThisMonthSum = this.appSettings.plansumoct;
					this.PlanLastMonthSum = this.appSettings.plansumsep;
					this.ManyDay = 31;
				} else if (this.ActMon == 10) {
					this.PlanThisMonth = this.appSettings.plannov;
					this.PlanLastMonth = this.appSettings.planoct;
					this.PlanThisMonthSum = this.appSettings.plansumnov;
					this.PlanLastMonthSum = this.appSettings.plansumoct;
					this.ManyDay = 30;
				} else if (this.ActMon == 11) {
					this.PlanThisMonth = this.appSettings.plandec;
					this.PlanLastMonth = this.appSettings.plannov;
					this.PlanThisMonthSum = this.appSettings.plansumdec;
					this.PlanLastMonthSum = this.appSettings.plansumnov;
					this.ManyDay = 31;
				}
				this.DayPercent = this.ActDay / this.ManyDay * 100;
				this.DayPercentMin = 100 - (this.ActDay / this.ManyDay * 100);
				this.ActDayMin = this.ManyDay - this.ActDay;
				this.PlanYear = eval(this.appSettings.planjan) + eval(this.appSettings.planfeb) + eval(this.appSettings.planmar) + eval(this.appSettings.planapr) + eval(this.appSettings.planmay) + eval(this.appSettings.planjun) + eval(this.appSettings.planjul) + eval(this.appSettings.planaug) + eval(this.appSettings.plansep) + eval(this.appSettings.planoct) + eval(this.appSettings.plannov) + eval(this.appSettings.plandec);
				this.PlanSummYear = eval(this.appSettings.plansumjan) + eval(this.appSettings.plansumfeb) + eval(this.appSettings.plansummar) + eval(this.appSettings.plansumapr) + eval(this.appSettings.plansummay) + eval(this.appSettings.plansumjun) + eval(this.appSettings.plansumjul) + eval(this.appSettings.plansumaug) + eval(this.appSettings.plansumsep) + eval(this.appSettings.plansumoct) + eval(this.appSettings.plansumnov) + eval(this.appSettings.plansumdec);







			}).catch(({ error }) => {
			});
		},



		dealLoad() {

			this.dealsFilterValue(this.saveDealsFilter);


		},
		dealsFilterValue(value) {
			this.saveDealsFilter = value;
			this.dealsFilter = value;
			this.lineChartLoad = true;
			this.lineChartLoadSex = true;
			this.lineChartLoadVisitors = true;
			this.lineChartLoadFin = true;
			this.lineChartLoadVis = true;
			this.lineChartLoadPipeline = true;
			this.lineChartLoadStage = true;
			this.lineChartLoadTraf = true;
			this.lineChartLoadShop = true;
			this.lineChartLoadPay = true;
			this.lineChartLoadGid = true;
			this.lineChartLoadAge = true;
			this.lineChartLoadVel = true;
			this.axiosGet('crm/deal-overview', {
				params: {
					filter: this.dealsFilter,
					all: this.allMuseums
				}
			}).then(response => {

				if (this.dealsFilter == "mod_week_this") {
					this.PlanData = eval(this.PlanThisMonth) / 4;
					this.PlanDataSum = eval(this.PlanThisMonthSum) / 4;
					this.dealsFilterSort = 1;
				} else if (this.dealsFilter == "mod_week_last") {
					this.PlanData = eval(this.PlanThisMonth) / 4;
					this.PlanDataSum = eval(this.PlanThisMonthSum) / 4;
					this.dealsFilterSort = 1;
				} else if (this.dealsFilter == "this_month") {
					this.PlanData = eval(this.PlanThisMonth);
					this.PlanDataSum = eval(this.PlanThisMonthSum);
					this.dealsFilterSort = 1;
				} else if (this.dealsFilter == "last_month") {
					this.PlanData = eval(this.PlanThisMonth);
					this.PlanDataSum = eval(this.PlanLastMonthSum);
					this.dealsFilterSort = 1;
				} else if (this.dealsFilter == "this_year") {
					this.PlanData = this.PlanYear;
					this.PlanDataSum = this.PlanSummYear;
					this.dealsFilterSort = 1;
				} else if (this.dealsFilter == "this_day" || this.dealsFilter == "last_day") {
					this.dealsFilterSort = 0;

				}

				if (this.dealsFilterSort == 0) {
					this.StyleGug = {
						height: '90px',
						marginTop: '40px',
						fontSize: '50px'
					}
				} else {
					this.StyleGug = {
						fontSize: '40px'
					}
				}


				if (response.data.visitors == 0) {
					this.lineGug.needleValue = 0;
				} else if (response.data.visitors > this.PlanData) {
					this.lineGug.needleValue = 100;
				} else {
					this.lineGug.needleValue = response.data.visitors / this.PlanData * 100;
				}
				this.lineGug.rangeLabel = ['0', String(this.PlanData)];
				this.lineGug.arcLabels = [Math.round(this.PlanData - (this.PlanData / 100 * 30)), Math.round(this.PlanData - (this.PlanData / 100 * 15))];
				this.DisplayVisitors = response.data.visitors;


				if (response.data.summ == 0) {
					this.lineGugFin.needleValue = 0;
				} else if (response.data.summ > this.PlanDataSum) {
					this.lineGugFin.needleValue = 100;
				} else {
					this.lineGugFin.needleValue = response.data.summ / this.PlanDataSum * 100;
				}
				this.lineGugFin.rangeLabel = ['0', String(this.PlanDataSum)];
				this.lineGugFin.arcLabels = [Math.round(this.PlanDataSum - (this.PlanDataSum / 100 * 30)), Math.round(this.PlanDataSum - (this.PlanDataSum / 100 * 15))];
				this.DisplayFin = response.data.summ;



				this.listTraf = response.data.traf_list;
				this.listPipeline = response.data.pipeline_list;
				this.listSex = response.data.sex_list;
				this.listAge = response.data.age_list;
				this.listStage = response.data.stage_list;
				this.listPay = response.data.pay_list;



				this.labelsTraf = response.data.traf_labels;
				this.labelsPipeline = response.data.pipeline_labels;
				this.labelsSex = response.data.sex_labels;
				this.labelsAge = response.data.age_labels;
				this.labelsStage = response.data.stage_labels;
				this.labelsPay = response.data.pay_labels;










				this.listVis.forEach((element, index) => {
					element.value = response.data.vis_list[index].value;
				})


				/*this.listTraf.forEach((element, index) => {
				   element.value = response.data.traf_list[index].value;
			   })
			   this.listPipeline.forEach((element, index) => {
				   element.value = response.data.pipeline_list[index].value;
			   })
			   */


				this.listShop.forEach((element, index) => {
					element.value = response.data.shop_list[index].value;
				})
				this.listPay.forEach((element, index) => {
					element.value = response.data.pay_list[index].value;
				})
				/*this.listGid.forEach((element, index) => {
					element.value = response.data.gid_list[index].value;
				})*/




				this.lineTypeSex.forEach((element, index) => {
					element.data = response.data.sex_type;
				})
				this.lineTypeVis.forEach((element, index) => {
					element.data = response.data.vis_type;
				})
				this.lineTypePipeline.forEach((element, index) => {
					element.data = response.data.pipeline_type;
				})
				this.lineTypeStage.forEach((element, index) => {
					element.data = response.data.stage_type;
				})
				this.lineTypeTraf.forEach((element, index) => {
					element.data = response.data.traf_type;
				})


				this.lineTypeShop.forEach((element, index) => {
					element.data = response.data.shop_type;
				})
				this.lineTypePay.forEach((element, index) => {
					element.data = response.data.pay_type;
				})
				/*this.lineTypeGid.forEach((element, index) => {
					element.data = response.data.gid_type;
				})*/
				this.lineTypeAge.forEach((element, index) => {
					element.data = response.data.age_type;
				})
				this.lineTypeAges.forEach((element, index) => {
					element.data = response.data.age_type;
				})
				this.lineChartData.forEach((element, index) => {
					element.data = [this.PlanData - response.data.total_deal_overview, response.data.total_deal_overview]
				})
				this.totalDealOverview = response.data.total_deal_overview
				if (this.dealsFilter == "this_month") {
					this.PlanDataSum = this.PlanThisMonthSum;
				} else {
					this.PlanDataSum = this.PlanLastMonthSum;
				}
				this.lineChartDataVel.forEach((element, index) => {
					element.data = [this.PlanDataSum - response.data.summ, response.data.summ]
				})

				this.totalDealOverview = response.data.total_deal_overview
				this.totalDealOverviewVel = response.data.summ
			}).finally(() => {
				this.lineChartLoad = false,
					this.lineChartLoadSex = false,
					this.lineChartLoadVisitors = false,
					this.lineChartLoadFin = false,
					this.lineChartLoadVis = false,
					this.lineChartLoadPipeline = false,
					this.lineChartLoadStage = false,
					this.lineChartLoadTraf = false,
					this.lineChartLoadShop = false,
					this.lineChartLoadPay = false,
					this.lineChartLoadGid = false,
					this.lineChartLoadAge = false,
					this.lineChartLoadVel = false
			})
		},
	}
}
</script>
